import type { CSSProperties, SVGProps } from 'react'
import classes from './icon.module.css'

export type FilterListProps = SVGProps<SVGSVGElement> & {
  className?: string
  style?: CSSProperties
}
export function FilterList(props: FilterListProps) {
  const { className, style, ...rest } = props

  const cls = `${classes.root} ${className || ''}`
  return (
    <svg
      aria-hidden="true"
      className={cls}
      focusable="false"
      viewBox="0 0 24 24"
      {...rest}
      data-testid="FilterListIcon"
      style={style}
    >
      <path d="M10 18h4v-2h-4zM3 6v2h18V6zm3 7h12v-2H6z" />
    </svg>
  )
}
